import Dexie from "dexie";

const db = new Dexie("AppDatabase");

// Define the database schema and versioning
// Add a new version for the issues and badges stores
db.version(25).stores({
  cards:
    "++id, CardId, IsActive, CustomerId, AppId, Name, SubName, coverImage, elevationImageId, [CardId+CustomerId]",
  pois: "MarkerId, CustomerId, Title, SubTitle, Latitude, Longitude, ProximityDistanceMeters, imageId, Body, DirectionsLink, Website, Colour, Triggered, TypeId, Timings, DaysOpened, rootId",
  images: "++id, &imageUrl, blob",
  pdfs: "++id, CardId, imageId, Title",
  issues: "++id, cardId, description, photo, latitude, longitude, timestamp",
  badges:
    "++id, customerId, cardId, email, start, start1km, end1km, longitude, latitude, timestamp",
  header:
    "++id, CustomerId, Title, Subtitle, Blurb, Logo, MainImageCarousel, SecondFrontImage, BlogURL, Email, Phone, Address, Facebook, Twitter, LinkedIn, Instagram, Youtube,ViewTracking,CustomPageTitle,CustomPageHTML ",
  completedTrails: "&VisitorCardId, emailaddress, datetime",
  settings: "&key, value",
  tiles: "key,blob",
  news: "Id,Image,News,PostDate,Title,Link",
  notifications:
    "NotificationId	,Notification,DatePublished,NotificationType,StatusId",
  startedWalks: "++id, CardId	,Started,DateTime, Duration, Distance, Completed",
  views: "++id, sessionId, type, itemId, timestamp, synced",
  user: "++id, email, name, gender, age",
});

// Listen for errors during database initialization
db.open().catch(err => {
  console.error("Error initializing database:", err);
});

export default db;
